import isUnicodeSupported from "is-unicode-supported";

const unicode = isUnicodeSupported();

const defineIcon = (unicodeIcon: string, fallbackIcon: string) =>
  unicode ? unicodeIcon : fallbackIcon;

export const icons = {
  arrowRight: defineIcon("→", "→"),
  checkmark: defineIcon("✔", "√"),
  cross: defineIcon("✖", "×"),
  gear: defineIcon("⚙", "D"),
  info: defineIcon("ℹ", "i"),
  leftHalfCircle: defineIcon("◐", "o"),
  warning: defineIcon("‼", "‼"),
};
